module.exports = __webpack_public_path__ + "img/storeNum4.6c0b5536.png";